import './site.scss'
import '@babel/polyfill'
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler.js'
import './plugins/vuetify'
import VueParticles from 'vue-particles'
import store from './store'
import App from './App.vue'
import router from './router'
// import '@/mock'
import '@/permission'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Toasted from 'vue-toasted'
import VueIntro from 'vue-introjs'
import 'intro.js/introjs.css'
import '@/assets/scss/reset.scss'
import '@/assets/scss/material-design-icons.scss'

import "overlayscrollbars/css/OverlayScrollbars.css";
import OverlayScrollbars from "overlayscrollbars";
import { OverlayScrollbarsPlugin } from "overlayscrollbars-vue";

import errorMessage from '@/utils/unifiedErrorMessage.js'



// const BrowerLogger = require('alife-logger') // ARMS前端监控

// if (process.env.NODE_ENV === 'production' && window.location.host.indexOf('tutor.acadsoc.ph') > -1) {
//   const __bl = BrowerLogger.singleton({
//     pid: 'ihdx2@e475a3f3b22a878',
//     appType: 'web',
//     imgUrl: 'https://arms-retcode-sg.aliyuncs.com/r.png?',
//     sample: 20,
//     sendResource: true,
//     enableLinkTrace: true,
//     behavior: true,
//     useFmp: true
//   })
// }

Vue.use(errorMessage) // 针对microSeviceFormatRequest.js统一错误框


Vue.use(Toasted, {
  duration: 5000,
  position:'top-center'
})
Vue.use(VueParticles)
Vue.use(VueIntro)

Vue.config.productionTip = process.env.NODE_ENV === 'development'

Vue.config.errorHandler = errorHandler
Vue.prototype.$throw = (error) => errorHandler(error, this) // 捕获全局异常

Vue.use(OverlayScrollbarsPlugin)
Vue.use(OverlayScrollbars)

const main = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default main
